import type { IBankDetails } from './banks';

export enum UserRole {
  MERCHANT = 'MERCHANT',
  CLIENT = 'CLIENT',
  ADMIN = 'ADMIN',
}

export interface IUser {
  _id: string;
  email: string;
  username: string;
  password: string;
  role: 'MERCHANT' | 'CLIENT' | 'ADMIN';
  apikey: string;
  merchantId?: string;
  idNumber: string;
  address: string;
  city: string;
  province: string;
  country: string;
  cellNumber?: string;
  active: boolean;
  name: string;
  hasPassword: boolean;
  shouldWelcome: boolean;
  bankDetails?: IBankDetails;
  verifiedMobile?: boolean;
  verifiedEmail?: boolean;
  bankValidationPendingReference?: string;
  oneTimePass: string;
  passportState: string;
  passportNumber: string;
  postalCode: string;
}
